import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
// Import the static default data as fallback/initial population
import { getPortfolioData as getDefaultData } from '../data';

const PortfolioContext = createContext();

export const usePortfolio = () => useContext(PortfolioContext);

export const PortfolioProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const docRef = doc(db, "portfolio", "mainData");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          // If document doesn't exist, use default data and push it to Firestore
          console.log("No data found in Firestore. Initializing with default data...");
          const defaultData = getDefaultData();
          await setDoc(docRef, defaultData);
          setData(defaultData);
        }
      } catch (error) {
        console.error("Error fetching portfolio data:", error);
        // Fallback to local default data in case of error (e.g. offline)
        setData(getDefaultData());
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolio();
  }, []);

  const savePortfolioData = async (newData) => {
    try {
      const docRef = doc(db, "portfolio", "mainData");
      await setDoc(docRef, newData);
      setData(newData); // Update local state so UI reflects changes immediately
    } catch (error) {
      console.error("Error saving portfolio data:", error);
      throw error;
    }
  };

  return (
    <PortfolioContext.Provider value={{ data, loading, savePortfolioData }}>
      {children}
    </PortfolioContext.Provider>
  );
};
